// extracted by mini-css-extract-plugin
export default {"icon":"_69d2b576","favoritesItemProvider":"_af4bb36e"};